import { getUniverseAggregateLabel, UniverseMetric } from '@weenat/client/dist/core/universes'
import { Aggregations } from '@weenat/client/dist/enums'
import { useIntl } from '@weenat/wintl'
import { RestrictionReason } from 'app/src/hooks/useIsAppAccessRestricted'
import { useToggleFeature } from 'app/state'
import { memo } from 'react'
import useUniverseBackgroundMapContext from '../universes/useUniverseBackgroundMapContext'
import { PlotListItemsVariants } from './PlotListItemMetricSummary'
import PlotListItemValue, { PlotSummaryValue } from './PlotListItemValue'
import PlotListItemValuesContainer from './PlotListItemValuesContainer'

interface NowMinMaxPlotListItemValuesProps {
  now: PlotSummaryValue
  max: PlotSummaryValue
  min?: PlotSummaryValue
  metric: UniverseMetric
  /** All values are restricted in the same way -- No need to pass isVirtualDevice  */
  isRestricted: boolean
  reason: RestrictionReason
  variant: PlotListItemsVariants
}

/** PlotListItem values for Humidities */
const NowMinMaxPlotListItemValues: FC<NowMinMaxPlotListItemValuesProps> = ({
  now,
  min,
  max,
  metric,
  isRestricted,
  reason,
  variant
}) => {
  const { t } = useIntl()
  const [{ smv }] = useToggleFeature()
  const { aggregate } = useUniverseBackgroundMapContext()

  return (
    <PlotListItemValuesContainer $isRestricted={isRestricted}>
      <PlotListItemValue
        isMainValue
        value={now}
        name={t(`map.universes.aggregate.${getUniverseAggregateLabel('real-time', smv)}`)}
        metric={metric}
        selected={aggregate === Aggregations.latest}
        isRestricted={isRestricted}
        reason={reason}
        variant={variant}
      />
      <PlotListItemValue
        value={min}
        name={t('map.universes.aggregate.min-measured-today')}
        metric={metric}
        selected={aggregate === Aggregations.minimum}
        isRestricted={isRestricted}
        reason={reason}
        variant={variant}
      />
      <PlotListItemValue
        value={max}
        name={t('map.universes.aggregate.max-measured-today')}
        metric={metric}
        selected={aggregate === Aggregations.maximum}
        isRestricted={isRestricted}
        reason={reason}
        variant={variant}
      />
    </PlotListItemValuesContainer>
  )
}

export default memo(NowMinMaxPlotListItemValues)
